const SizePackingFields = [
    {
        name: 'Size',
        code: 'sizeName',
        column: true,
        sortable: true,
        align: 'center',
        defaultFilter: true,
        listFilter: true,
        width: 150
    },
    {
        name: 'Quantity',
        code: 'amount',
        column: true,
        sortable: true,
        defaultFilter: true,
        listFilter: true,
        align: 'center',
        width: 150
    }
];
export default SizePackingFields;
